export default () => document.scrollingElement || document.documentElement;
